import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright="Powered by 圣巴云科技"
      links={[
        {
          key: '圣巴云科技',
          title: '圣巴云科技',
          href: 'https://www.sebayun.com',
          blankTarget: true,
        },
        // {
        //   key: 'github',
        //   title: <GithubOutlined />,
        //   href: 'https://github.com/ant-design/ant-design-pro',
        //   blankTarget: true,
        // },
        // {
        //   key: '圣巴',
        //   title: '圣巴',
        //   href: 'https://www.sebayun.com',
        //   blankTarget: true,
        // },
      ]}
    />
  );
};

export default Footer;
